import React, { useContext } from 'react'
import Modal from './Modal'
import { keyContext } from '../KeyContext'

function ErrorModal({shown,children,errorText, errorNo,errorType,errorStatus}) {
    const {setShowErrorModal} = useContext(keyContext)

    function handleOkBtn () {
        setShowErrorModal(false)
    }

   return shown ? (
    <Modal open={shown}>
    
    <div style={{border:'1px solid white', width: '500px',height:'300px',backgroundColor:'white',padding:'20px',marginTop:'20px',borderRadius:'4px',position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'}}>
      
      <>
      {errorStatus ? 
         <p style={{fontWeight:900}}>Status :  {errorStatus}</p> 
            :      
         <p style={{fontWeight:900}}>Result :  {errorNo}</p> 
      }
      {errorType ?
          <p style={{fontWeight:900,height:'70%',overflow:'auto',border:'1px solid #dee0e3',borderRadius:'4px',padding:'5px'}}>errorType : {errorType}</p> 
           :
          <p style={{fontWeight:900,height:'70%',overflow:'auto',border:'1px solid #dee0e3',borderRadius:'4px',padding:'5px'}}>ErrorDescription : {errorText}</p> 
      }
      
      
       <button onClick={handleOkBtn} style={{backgroundColor:'#982f2f',color:'white',padding:'5px',width:'100px',borderRadius:'5px'}}>Ok</button>
        </>
      
    </div>
 
    </Modal>
  ) : ''
}

export default ErrorModal